import React from 'react';
import ReactDOM from 'react-dom';
import {
    BrowserRouter,
    Route,
    Switch
} from 'react-router-dom';

import indexRoutes from './routes/index.jsx';

import registerServiceWorker from './registerServiceWorker';

import './assets/css/bootstrap.min.css';
import './assets/sass/light-bootstrap-dashboard.css';
import './assets/css/demo.css';
import './assets/css/pe-icon-7-stroke.css';

import {AuthenticatedRoute} from 'services/AuthService.jsx'

import store from "redux/store/index";
import { addArticle } from "redux/actions/index";

window.store = store;
window.addArticle = addArticle;

// Add these lines:
if (process.env.NODE_ENV !== 'production' && true) {
  localStorage.setItem('debug', 'bark:*');
}

ReactDOM.render((
    <BrowserRouter>
        <Switch>
            {
                indexRoutes.map((prop,key) => {
                  if (prop.auth) {
                    return (<AuthenticatedRoute path={prop.path} component={prop.component} key={key}/>);
                  } else {
                    return (<Route path={prop.path} component={prop.component} key={key}/>)
                  }
                })
            }
        </Switch>
    </BrowserRouter>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js